export const OUTPUT_TABS = [
  { id: 'team', labelKey: 'team' },
  { id: 'partner', labelKey: 'partner' },
  { id: 'social', labelKey: 'social' },
] as const

export type OutputTabId = (typeof OUTPUT_TABS)[number]['id']
